import React from 'react';
import './_shimmer.scss';

// Skeleton placeholder used for loading states.
// variant="page" (default): title + grid of cards, for full-page loads.
// variant="lines": a few shimmering lines, for loaders inside cards, tabs and modals.
const ShimmerLoader = ({ cards = 6, variant = "page" }) => {
    if (variant === "lines") {
        return (
            <div className="shimmer-loader shimmer-loader-lines" role="status" aria-live="polite">
                <span className="shimmer-sr-only">Loading…</span>
                <div className="shimmer-block shimmer-line w-90" />
                <div className="shimmer-block shimmer-line w-75" />
                <div className="shimmer-block shimmer-line w-60" />
            </div>
        );
    }

    return (
        <div className="shimmer-loader" role="status" aria-live="polite">
            <span className="shimmer-sr-only">Loading…</span>
            <div className="shimmer-block shimmer-title" />
            <div className="shimmer-block shimmer-subtitle" />
            <div className="shimmer-grid">
                {Array.from({ length: cards }).map((_, index) => (
                    <div className="shimmer-card" key={index}>
                        <div className="shimmer-block shimmer-card-media" />
                        <div className="shimmer-block shimmer-line w-80" />
                        <div className="shimmer-block shimmer-line w-60" />
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ShimmerLoader;
